import type { ReactNode } from "react";
import { magicLetterBoxUrl, type MagicLetterDestination } from "../../../shared/magic-letter-box";

type Props = {
  source: string;
  campaign?: string;
  destination?: MagicLetterDestination;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
};

export function MagicLetterBoxLink({ source, campaign, destination, children, className, onClick }: Props) {
  return (
    <a
      href={magicLetterBoxUrl(source, { campaign, destination })}
      className={className ?? "inline-flex items-center justify-center rounded-xl bg-elfRed-ink px-6 py-3 text-center font-semibold text-white hover:bg-[#892638] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"}
      data-cta-type={`mlb-${source}`}
      onClick={() => {
        // Static placement identifiers only; never send names, email, or letter text.
        void fetch("/api/track-click", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cta_identifier: `mlb-${source}`.slice(0, 100) }),
          keepalive: true,
        }).catch(() => undefined);
        onClick?.();
      }}
    >
      {children}
    </a>
  );
}
